"use client";
import { useState, useRef, useEffect } from "react";
import Webcam from "react-webcam";
import { UploadIcon, XIcon } from "lucide-react";
import {
  server_post_data,
  maintainance_car_data,
  upload_image_to_folder,
} from "../../ServiceConnection/serviceconnection";
import { handleError } from "../../CommonJquery/CommonJquery";
const FinalChecks = ({
  onNext,
  onBack,
  cardata,
  MaintainanceData,
  ImageLink,
  setCount,
  BookingData,
  FromComeData,
}) => {
  const [damage, setDamage] = useState("");
  const [remarks, setRemarks] = useState("");
  const [seatCover, setSeatCover] = useState("");
  const [oilBottles, setOilBottles] = useState("");
  const [snowBrush, setSnowBrush] = useState("");
  const [verifyKey, setVerifyKey] = useState("");
  const [repairDetails, setRepairDetails] = useState("");
  const [futureNotes, setFutureNotes] = useState("");

  const [uploadedImages1, setUploadedImages1] = useState([]);
  const [uploadedImages2, setUploadedImages2] = useState([]);
  const [uploadedImages3, setUploadedImages3] = useState([]);
  const [isCameraOpen1, setIsCameraOpen1] = useState(false);
  const [isCameraOpen2, setIsCameraOpen2] = useState(false);
  const [isCameraOpen3, setIsCameraOpen3] = useState(false);
  const [repair_done_img, setRepairDoneImg] = useState(null);
  const [repair_done_img_preview, setRepairDoneImgPreview] = useState("");
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const webcamRef = useRef(null);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [carinspectiondata, setFormData] = useState({});
  const [coveredImage, setCoveredImage] = useState("");
  const [damageImage, setDamageImage] = useState("");
  const [errors, setErrors] = useState({
    uploadedImages1: "",
    remarks: "",
    damage: "",
    uploadedImages2: "",
    seatCover: "",
    oilBottles: "",
    snowBrush: "",
    verifyKey: "",
    repairDetails: "",
    futureNotes: "",
  });

  useEffect(() => {
    setDamage(MaintainanceData.damage_status);
    setRemarks(MaintainanceData.remark_dashboard_code);
    setSeatCover(MaintainanceData.seat_cover);
    setOilBottles(MaintainanceData.driver_oil_bottles);
    setSnowBrush(MaintainanceData.snow_brush);
    setVerifyKey(MaintainanceData.office_verify);
    setRepairDetails(MaintainanceData.details_for_repair);
    setFutureNotes(MaintainanceData.notes_for_future);
    if (MaintainanceData) {
      const image_repairs = MaintainanceData.pictures_of_repairs
        .split("@@@")
        .filter((item) => item !== "" && item !== "0")
        .map((item) => ({
          file: null,
          name: item,
        }));

      const images1 = [
        MaintainanceData?.coderead_image1,
        MaintainanceData?.coderead_image2,
        MaintainanceData?.coderead_image3,
        MaintainanceData?.coderead_image4,
      ]
        .filter(Boolean)
        .map((item) => ({
          file: null,
          name: item,
        }));
      const images2 = [
        MaintainanceData?.damage_image1,
        MaintainanceData?.damage_image2,
        MaintainanceData?.damage_image3,
        MaintainanceData?.damage_image4,
      ]
        .filter(Boolean)
        .map((item) => ({
          file: null,
          name: item,
        }));
      setFormData({
        images: images1,
        images1: images2,
        images3: image_repairs,
      });
      setUploadedImages1(images1.map((img) => img.name));
      setUploadedImages2(images2.map((img) => img.name));
      setUploadedImages3(image_repairs.map((img) => img.name));
    }
  }, [MaintainanceData]);
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    if (files.length + uploadedImages1.length > 4) {
      alert("You can only upload a maximum of 4 images.");
      return;
    }

    const remainingSlots = 4 - uploadedImages1.length;
    const filesToUpload = files.slice(0, remainingSlots);

    filesToUpload.forEach((file) => {
      const localImageUrl = URL.createObjectURL(file);

      // 1. Show image preview immediately
      // setUploadedImages1((prev) => [...prev, localImageUrl]);

      // 2. Upload image and store in formData
      uploadImageserver(file, 1);
    });

    // Clear error (if any)
  };

  const handleRemoveImage = (index) => {
    const updatedImages1 = uploadedImages1.filter((_, i) => i !== index);
    setUploadedImages1(updatedImages1);

    setFormData((prevData) => {
      const updatedFormImages = (prevData.images || []).filter(
        (_, i) => i !== index
      );
      return {
        ...prevData,
        images: updatedFormImages,
      };
    });
  };

  const openCamera = async () => {
    if (uploadedImages1.length >= 4) {
      alert("You can only upload a maximum of 4 images.");
      return;
    }

    try {
      const constraints = {
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: "environment",
        },
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      streamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }

      setIsCameraOpen1(true);
      //console.log("Camera opened successfully");
    } catch (error) {
      console.error("Error opening camera:", error);
      alert(
        "Failed to open camera. Please make sure you've granted camera permission."
      );
    }
  };

  const captureImage1 = () => {
    if (!webcamRef.current) {
      console.error("Webcam reference is missing");
      return;
    }

    try {
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) {
        console.error("Failed to capture screenshot");
        return;
      }

      //console.log("Image captured:", imageSrc.substring(0, 50) + "...");
      const updatedImages = [...uploadedImages1, imageSrc].slice(0, 4);
      setUploadedImages1(updatedImages);

      // Clear error when image is captured
      if (updatedImages.length > 0) {
        setErrors((prev) => ({ ...prev, uploadedImages1: "" }));
      }

      closeCamera();
    } catch (error) {
      console.error("Error capturing image:", error);
      alert("Failed to capture image. Please try again.");
    }
  };

  const closeCamera = () => {
    setIsCameraOpen1(false);
    setIsCameraOpen2(false);
    setIsCameraOpen3(false);
    if (streamRef.current) {
      const tracks = streamRef.current.getTracks();
      tracks.forEach((track) => track.stop());
    }
    //console.log("Camera modal closed");
  };
  const handleWebcamError = (error) => {
    console.error("Webcam error:", error);
    alert(
      "Failed to access camera. Please make sure you've granted camera permission and that your camera is working properly."
    );
    closeCamera();
  };

  ////-----------------damage Upload camerra capture

  const handleFileChange2 = (event) => {
    const files = Array.from(event.target.files);

    if (files.length + uploadedImages2.length > 4) {
      alert("You can only upload a maximum of 4 images.");
      return;
    }

    const remainingSlots = 4 - uploadedImages2.length;
    const filesToUpload = files.slice(0, remainingSlots);

    filesToUpload.forEach((file) => {
      const localImageUrl = URL.createObjectURL(file);

      // 1. Show image preview immediately
      // setUploadedImages2((prev) => [...prev, localImageUrl]);

      // 2. Upload image and store in formData
      uploadImageserver(file, 2);
    });

    // Clear error (if any)
  };

  const handleFileChange3 = (event) => {
    const files = Array.from(event.target.files);

    if (files.length + uploadedImages3.length > 4) {
      alert("You can only upload a maximum of 4 images.");
      return;
    }

    const remainingSlots = 4 - uploadedImages3.length;
    const filesToUpload = files.slice(0, remainingSlots);

    filesToUpload.forEach((file) => {
      const localImageUrl = URL.createObjectURL(file);

      // 1. Show image preview immediately
      // setUploadedImages2((prev) => [...prev, localImageUrl]);

      // 2. Upload image and store in formData
      uploadImageserver(file, 3);
    });

    // Clear error (if any)
  };

  const handleRemoveImage2 = (index) => {
    const updatedImages2 = uploadedImages2.filter((_, i) => i !== index);
    setUploadedImages2(updatedImages2);
    setFormData((prevData) => {
      const updatedFormImages = (prevData.images2 || []).filter(
        (_, i) => i !== index
      );
      return {
        ...prevData,
        images2: updatedFormImages,
      };
    });
  };

  const handleRemoveImage3 = (index) => {
    const updatedImages3 = updatedImages3.filter((_, i) => i !== index);
    setUploadedImages3(updatedImages3);
    setFormData((prevData) => {
      const updatedFormImages = (prevData.images2 || []).filter(
        (_, i) => i !== index
      );
      return {
        ...prevData,
        images2: updatedFormImages,
      };
    });
  };

  const openCamera2 = async () => {
    if (uploadedImages2.length >= 4) {
      alert("You can only upload a maximum of 4 images.");
      return;
    }

    try {
      const constraints = {
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: "environment",
        },
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      streamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }

      setIsCameraOpen2(true);
      //console.log("Camera opened successfully");
    } catch (error) {
      console.error("Error opening camera:", error);
      alert(
        "Failed to open camera. Please make sure you've granted camera permission."
      );
    }
  };

  const openCamera3 = async () => {
    if (uploadedImages3.length >= 4) {
      alert("You can only upload a maximum of 4 images.");
      return;
    }

    try {
      const constraints = {
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: "environment",
        },
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      streamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }

      setIsCameraOpen3(true);
      //console.log("Camera opened successfully");
    } catch (error) {
      console.error("Error opening camera:", error);
      alert(
        "Failed to open camera. Please make sure you've granted camera permission."
      );
    }
  };

  const captureImage2 = () => {
    if (!webcamRef.current) {
      console.error("Webcam reference is missing");
      return;
    }

    try {
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) {
        console.error("Failed to capture screenshot");
        return;
      }

      //console.log("Image captured:", imageSrc.substring(0, 50) + "...");
      const updatedImages = [...uploadedImages2, imageSrc].slice(0, 4);
      setUploadedImages2(updatedImages);

      // Clear error when image is captured
      if (updatedImages.length > 0) {
        setErrors((prev) => ({ ...prev, uploadedImages2: "" }));
      }

      closeCamera();
    } catch (error) {
      console.error("Error capturing image:", error);
      alert("Failed to capture image. Please try again.");
    }
  };

  const captureImage3 = () => {
    if (!webcamRef.current) {
      console.error("Webcam reference is missing");
      return;
    }

    try {
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) {
        console.error("Failed to capture screenshot");
        return;
      }

      //console.log("Image captured:", imageSrc.substring(0, 50) + "...");
      const updatedImages = [...uploadedImages3, imageSrc].slice(0, 4);
      setUploadedImages3(updatedImages);

      // Clear error when image is captured
      if (updatedImages.length > 0) {
        setErrors((prev) => ({ ...prev, uploadedImages2: "" }));
      }

      closeCamera();
    } catch (error) {
      console.error("Error capturing image:", error);
      alert("Failed to capture image. Please try again.");
    }
  };

  /// REPAIR DONT iMG
  const handleRepairDoneImageUpload = (e) => {
    const file = e.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      //console.log("Repair Done Image:", file);
      uploadImageserver(file, 3);
    } else {
      //console.log("Invalid file format. Please upload PNG/JPG/JPEG images.");
      setRepairDoneImg(null);
      setRepairDoneImgPreview("");
      setErrors((prevErrors) => ({
        ...prevErrors,
        repair_done_img:
          "Invalid file format. Please upload PNG/JPG/JPEG images.",
      }));
      setFormData((prevData) => ({
        ...prevData,
        pictures_of_repairs: null,
      }));
    }
  };
  const handleRemoveRepairDoneImage = () => {
    setRepairDoneImg(null);
    setRepairDoneImgPreview("");
    document.getElementById("repairDoneImageInput").value = ""; // Reset file input
  };

  // Add a new function to validate fields before the handleSubmit function
  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Validate required fields
    if (uploadedImages1.length === 0) {
      newErrors.uploadedImages1 = "Please fill this field";
      isValid = false;
    } else {
      newErrors.uploadedImages1 = "";
    }

    if (!remarks.trim()) {
      newErrors.remarks = "Please fill this field";
      isValid = false;
    } else {
      newErrors.remarks = "";
    }

    if (!damage) {
      newErrors.damage = "Please fill this field";
      isValid = false;
    } else {
      newErrors.damage = "";
    }

    // Validate damage images only if damage is "someDamage"
    if (damage === "someDamage" && uploadedImages2.length === 0) {
      newErrors.uploadedImages2 = "Please fill this field";
      isValid = false;
    } else {
      newErrors.uploadedImages2 = "";
    }

    if (!seatCover) {
      newErrors.seatCover = "Please fill this field";
      isValid = false;
    } else {
      newErrors.seatCover = "";
    }

    if (!oilBottles) {
      newErrors.oilBottles = "Please fill this field";
      isValid = false;
    } else {
      newErrors.oilBottles = "";
    }

    if (!snowBrush) {
      newErrors.snowBrush = "Please fill this field";
      isValid = false;
    } else {
      newErrors.snowBrush = "";
    }

    if (!verifyKey) {
      newErrors.verifyKey = "Please fill this field";
      isValid = false;
    } else {
      newErrors.verifyKey = "";
    }

    if (!repairDetails.trim()) {
      newErrors.repairDetails = "Please fill this field";
      isValid = false;
    } else {
      newErrors.repairDetails = "";
    }

    setErrors(newErrors);
    return isValid;
  };

  const uploadImageserver = async (file, flag) => {
    const fd = new FormData();
    fd.append("image", file);
    // console.log(flag, "flag");
    try {
      const response = await server_post_data(upload_image_to_folder, fd);

      if (response.data.error) {
        handleError(response.data.message);
      } else {
        const uploadedImageName = response.data.message.image_uploaded;
        if (flag == 1) {
          // Append image data to formData.images array
          setFormData((prevData) => ({
            ...prevData,
            images: [
              ...(prevData.images || []),
              {
                file: file,
                name: uploadedImageName,
              },
            ],
          }));

          //console.log("uploadedImageName", uploadedImageName);
          setUploadedImages1((prev) => [...prev, uploadedImageName]);
          // Clear any error related to image upload
          setErrors((prev) => ({ ...prev, uploadedImages1: "" }));
        } else if (flag == 2) {
          setFormData((prevData) => ({
            ...prevData,
            images2: [
              ...(prevData.images2 || []),
              {
                file: file,
                name: uploadedImageName,
              },
            ],
          }));
          setUploadedImages2((prev) => [...prev, uploadedImageName]);
          // Clear any error related to image upload
          setErrors((prev) => ({ ...prev, uploadedImages2: "" }));
        } else if (flag == 2) {
          setFormData((prevData) => ({
            ...prevData,
            images2: [
              ...(prevData.images2 || []),
              {
                file: file,
                name: uploadedImageName,
              },
            ],
          }));

          // Clear any error related to image upload
          setErrors((prev) => ({ ...prev, uploadedImages2: "" }));
        } else if (flag == 3) {
          setFormData((prevData) => ({
            ...prevData,
            images3: [
              ...(prevData.images3 || []),
              {
                file: file,
                name: uploadedImageName,
              },
            ],
          }));
          setUploadedImages3((prev) => [...prev, uploadedImageName]);
          // Clear any error related to image upload
          setErrors((prev) => ({ ...prev, uploadedImages3: "" }));
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  // Modify the handleSubmit function to use validation and save data
  const handleNext = async () => {
    if (validateForm()) {
      const finalCheckData = {
        uploadedImages1,
        remarks,
        damage,
        uploadedImages2: damage === "someDamage" ? uploadedImages2 : [],
        seatCover,
        oilBottles,
        snowBrush,
        verifyKey,
        repairDetails,
        futureNotes,
      };

      // //console.log("Final Check Data:", finalCheckData)
      setshowLoaderAdmin(true);
      const fd = new FormData();
      fd.append("car_id", cardata.primary_id);
      fd.append("booking_id", cardata.current_booking_id);
      fd.append("user_id", BookingData?.user_id || 0);
      fd.append("damage_status", damage);
      fd.append("seat_cover", seatCover);
      fd.append("remark_dashboard_code", remarks);
      fd.append("driver_oil_bottles", oilBottles);
      fd.append("snow_brush", snowBrush);
      fd.append("office_verify", verifyKey);
      fd.append("details_for_repair", repairDetails);
      fd.append("notes_for_future", futureNotes);
      fd.append("repair_done_img", repair_done_img);
      fd.append("step_for_maintenance", 7);

      (carinspectiondata.images || []).forEach((imgObj, index) => {
        fd.append(`coderead_image${index + 1}`, imgObj.name);
      });
      (carinspectiondata.images2 || []).forEach((imgObj, index) => {
        fd.append(`damage_image${index + 1}`, imgObj.name);
      });
      (carinspectiondata.images3 || []).forEach((imgObj, index) => {
        fd.append(`repairs_image${index + 1}`, imgObj.name);
      });
      fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
      fd.append("save_or_edit_type", FromComeData);
      await server_post_data(maintainance_car_data, fd)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            onNext();
            setCount(8);
          }
          setshowLoaderAdmin(false);
        })
        .catch((error) => {
          handleError("network");
          setshowLoaderAdmin(false);
        });
      if (onNext) {
        onNext(finalCheckData);
      }
    } else {
      //console.log("Form validation failed");
    }
  };

  // For remarks
  const handleRemarksChange = (e) => {
    const value = e.target.value;
    setRemarks(value);
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, remarks: "" }));
    }
  };

  // For damage
  const handleDamageChange = (value) => {
    setDamage(value);
    setErrors((prev) => ({ ...prev, damage: "" }));
  };

  // For seatCover
  const handleSeatCoverChange = (value) => {
    setSeatCover(value);
    setErrors((prev) => ({ ...prev, seatCover: "" }));
  };

  // For oilBottles
  const handleOilBottlesChange = (value) => {
    setOilBottles(value);
    setErrors((prev) => ({ ...prev, oilBottles: "" }));
  };

  // For snowBrush
  const handleSnowBrushChange = (value) => {
    setSnowBrush(value);
    setErrors((prev) => ({ ...prev, snowBrush: "" }));
  };

  // For verifyKey
  const handleVerifyKeyChange = (value) => {
    setVerifyKey(value);
    setErrors((prev) => ({ ...prev, verifyKey: "" }));
  };

  // For repairDetails
  const handleRepairDetailsChange = (e) => {
    const value = e.target.value;
    setRepairDetails(value);
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, repairDetails: "" }));
    }
  };
  // console.log(carinspectiondata);
  // For futureNotes
  const handleFutureNotesChange = (e) => {
    const value = e.target.value;
    setFutureNotes(value);
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, futureNotes: "" }));
    }
  };
  return (
    <>
      <div className="final-checks-container">
        <h3 className="section-title text-primary">
          Damage & Final Checks <span className="mandory_field">*</span>
        </h3>

        <div className="section">
          <h5>
            Take Pictures of Code Readings{" "}
            <span className="mandory_field">*</span>
          </h5>
          <span
            className="error-text"
            style={{
              color: "red",
              display: errors.uploadedImages1 ? "block" : "none",
            }}
          >
            {errors.uploadedImages1}
          </span>
          <div className="media-upload-section">
            <div className="row">
              <div className="col-sm">
                <div className="img_upd_contr">
                  {" "}
                  <div
                    className="media-placeholder upload_img_contr"
                    onClick={() => {
                      if (uploadedImages1.length < 4) {
                        document.getElementById("fileInput").click();
                      }
                    }}
                    style={{
                      opacity: uploadedImages1.length >= 4 ? 0.5 : 1,
                      pointerEvents:
                        uploadedImages1.length >= 4 ? "none" : "auto",
                    }}
                  >
                    <div className="empty-upload-text">
                      <i className="bi bi-cloud-upload"></i>
                      <span>Browse</span>
                    </div>

                    <input
                      type="file"
                      id="fileInput"
                      accept="image/*"
                      multiple
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </div>
                  <div
                    className="media-placeholder capcureImg"
                    onClick={openCamera}
                    style={{
                      opacity: uploadedImages1.length >= 4 ? 0.5 : 1,
                      pointerEvents:
                        uploadedImages1.length >= 4 ? "none" : "auto",
                    }}
                  >
                    <div className="empty-upload-text">
                      <i className="bi bi-cloud-upload"></i>
                      <span>Capture</span>
                    </div>

                    <input
                      type="file"
                      id="fileInput"
                      accept="image/*"
                      multiple
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
              </div>
              {[...Array(4)].map((_, index) => (
                <div
                  key={index}
                  className="col-sm"
                  style={{ position: "relative" }}
                >
                  {uploadedImages1[index] && (
                    <div
                      className="hoverRemoveImg"
                      onClick={() => handleRemoveImage(index)}
                    >
                      <XIcon className="rmv_icn" />
                    </div>
                  )}
                  <div className="media-placeholder car-image">
                    {console.log(ImageLink + uploadedImages1[index])}
                    {uploadedImages1[index] ? (
                      <img
                        src={
                          ImageLink + uploadedImages1[index] ||
                          "/placeholder.svg"
                        }
                        alt={`Uploaded ${index + 1}`}
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                      />
                    ) : (
                      <div
                        className="empty-upload-text"
                        style={{ opacity: "0.5" }}
                      >
                        <UploadIcon size={20} color="#aaa" />
                        <span style={{ marginLeft: "10px" }}>Empty</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          {isCameraOpen1 && (
            <div
              className="camera-modal"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.9)",
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
              }}
            >
              <div className="container" style={{ maxWidth: "1200px" }}>
                <div
                  className="row"
                  style={{
                    backgroundColor: "#222",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <div className="col-8" style={{ padding: "0" }}>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#000",
                        minHeight: "400px",
                      }}
                    >
                      <Webcam
                        ref={webcamRef}
                        audio={false}
                        screenshotFormat="image/jpeg"
                        videoConstraints={{
                          width: 1280,
                          height: 720,
                          facingMode: "user",
                        }}
                        onUserMediaError={handleWebcamError}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="col-4"
                    style={{
                      padding: "20px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      backgroundColor: "#333",
                    }}
                  >
                    <h4
                      style={{
                        color: "white",
                        marginBottom: "20px",
                        textAlign: "center",
                      }}
                    >
                      Camera Capture
                    </h4>
                    <p
                      style={{
                        color: "#ccc",
                        marginBottom: "30px",
                        textAlign: "center",
                      }}
                    >
                      Position yourself in the frame and click "Take Photo" when
                      ready.
                    </p>
                    <button
                      onClick={captureImage1}
                      style={{
                        padding: "12px 0",
                        margin: "10px 0",
                        backgroundColor: "var(--primary-color)",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                    >
                      Take Photo
                    </button>
                    <button
                      onClick={() => {
                        closeCamera();
                      }}
                      style={{
                        padding: "12px 0",
                        margin: "10px 0",
                        backgroundColor: "#f44336",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="section">
          <div className="row">
            <div className="col-md-4">
              <h5>
                Remarks for Codes on Dashboard{" "}
                <span className="mandory_field">*</span>
              </h5>
              <span
                className="error-text"
                style={{
                  color: "red",
                  display: errors.remarks ? "block" : "none",
                }}
              >
                {errors.remarks}
              </span>
            </div>
            <div className="col-md-8">
              <textarea
                className="form-control"
                rows="2"
                value={remarks}
                onChange={handleRemarksChange}
              ></textarea>
            </div>
          </div>
        </div>

        <div className="section">
          <div
            className="row align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="col-md-2">
              <h5 className="mb-0">
                Damage: <span className="mandory_field">*</span>
              </h5>
              <span
                className="error-text"
                style={{
                  color: "red",
                  display: errors.damage ? "block" : "none",
                }}
              >
                {errors.damage}
              </span>
            </div>
            <div className="col-md-9">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn btn-outline-secondary ${
                    damage === "noDamage" ? "active goodActive" : ""
                  }`}
                  onClick={() => handleDamageChange("noDamage")}
                >
                  No Damage
                </button>
                <button
                  className={`btn btn-outline-secondary ${
                    damage === "someDamage" ? "active needRepairActive" : ""
                  }`}
                  onClick={() => handleDamageChange("someDamage")}
                >
                  Damage
                </button>
              </div>
            </div>
          </div>
        </div>
        {/**---------------Damage section- 2-------------- */}
        {damage === "someDamage" && (
          <div className="section">
            <span
              className="error-text"
              style={{
                color: "red",
                display: errors.uploadedImages2 ? "block" : "none",
              }}
            >
              {errors.uploadedImages2}
            </span>
            <div className="media-upload-section">
              <div className="row">
                <div className="col">
                  <div className="img_upd_contr">
                    {" "}
                    <div
                      className="media-placeholder upload_img_contr"
                      onClick={() => {
                        if (uploadedImages2.length < 4) {
                          document.getElementById("fileInput2").click();
                        }
                      }}
                      style={{
                        opacity: uploadedImages2.length >= 4 ? 0.5 : 1,
                        pointerEvents:
                          uploadedImages2.length >= 4 ? "none" : "auto",
                      }}
                    >
                      <div className="empty-upload-text">
                        <i className="bi bi-cloud-upload"></i>
                        <span>Browse</span>
                      </div>

                      <input
                        type="file"
                        id="fileInput2"
                        accept="image/*"
                        multiple
                        style={{ display: "none" }}
                        onChange={handleFileChange2}
                      />
                    </div>
                    <div
                      className="media-placeholder capcureImg"
                      onClick={openCamera2}
                      style={{
                        opacity: uploadedImages2.length >= 4 ? 0.5 : 1,
                        pointerEvents:
                          uploadedImages2.length >= 4 ? "none" : "auto",
                      }}
                    >
                      <div className="empty-upload-text">
                        <i className="bi bi-cloud-upload"></i>
                        <span>Capture</span>
                      </div>

                      <input
                        type="file"
                        id="fileInput"
                        accept="image/*"
                        multiple
                        style={{ display: "none" }}
                        onChange={handleFileChange2}
                      />
                    </div>
                  </div>
                </div>
                {[...Array(4)].map((_, index) => (
                  <div
                    key={index}
                    className="col"
                    style={{ position: "relative" }}
                  >
                    {uploadedImages2[index] && (
                      <div
                        className="hoverRemoveImg"
                        onClick={() => handleRemoveImage2(index)}
                      >
                        <XIcon className="rmv_icn" />
                      </div>
                    )}
                    <div className="media-placeholder car-image">
                      {uploadedImages2[index] ? (
                        <img
                          src={
                            ImageLink + uploadedImages2[index] ||
                            "/placeholder.svg"
                          }
                          alt={`Uploaded ${index + 1}`}
                          style={{ maxWidth: "100%", maxHeight: "100%" }}
                        />
                      ) : (
                        <div
                          className="empty-upload-text"
                          style={{ opacity: "0.5" }}
                        >
                          <UploadIcon size={20} color="#aaa" />
                          <span style={{ marginLeft: "10px" }}>Empty</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {isCameraOpen2 && (
              <div
                className="camera-modal"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0,0,0,0.9)",
                  zIndex: 1000,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <div className="container" style={{ maxWidth: "1200px" }}>
                  <div
                    className="row"
                    style={{
                      backgroundColor: "#222",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <div className="col-8" style={{ padding: "0" }}>
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "#000",
                          minHeight: "400px",
                        }}
                      >
                        <Webcam
                          ref={webcamRef}
                          audio={false}
                          screenshotFormat="image/jpeg"
                          videoConstraints={{
                            width: 1280,
                            height: 720,
                            facingMode: "user",
                          }}
                          onUserMediaError={handleWebcamError}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className="col-4"
                      style={{
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        backgroundColor: "#333",
                      }}
                    >
                      <h4
                        style={{
                          color: "white",
                          marginBottom: "20px",
                          textAlign: "center",
                        }}
                      >
                        Camera Capture
                      </h4>
                      <p
                        style={{
                          color: "#ccc",
                          marginBottom: "30px",
                          textAlign: "center",
                        }}
                      >
                        Position yourself in the frame and click "Take Photo"
                        when ready.
                      </p>
                      <button
                        onClick={captureImage2}
                        style={{
                          padding: "12px 0",
                          margin: "10px 0",
                          backgroundColor: "var(--primary-color)",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                      >
                        Take Photo
                      </button>
                      <button
                        onClick={() => {
                          closeCamera();
                        }}
                        style={{
                          padding: "12px 0",
                          margin: "10px 0",
                          backgroundColor: "#f44336",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="section">
          <div className="row align-items-center">
            <div className="col-md-3">
              <h5 className="mb-0">
                Seat Cover Installed?<span className="mandory_field">*</span>
              </h5>
              <span
                className="error-text"
                style={{
                  color: "red",
                  display: errors.seatCover ? "block" : "none",
                }}
              >
                {errors.seatCover}
              </span>
            </div>
            <div className="col-md-9">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn btn-outline-secondary ${
                    seatCover === "yes" ? "active goodActive" : ""
                  }`}
                  onClick={() => handleSeatCoverChange("yes")}
                >
                  Yes
                </button>
                <button
                  className={`btn btn-outline-secondary ${
                    seatCover === "no" ? "active needRepairActive" : ""
                  }`}
                  onClick={() => handleSeatCoverChange("no")}
                >
                  No
                </button>
                <button
                  className={`btn btn-outline-secondary ${
                    seatCover === "Replaced" ? "active needRepairActive" : ""
                  }`}
                  onClick={() => handleSeatCoverChange("Replaced")}
                >
                  Replaced
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="section">
          <div className="row align-items-center">
            <div className="col-md-3">
              <h5 className="mb-0">
                Check if Driver has Oil Bottles:{" "}
                <span className="mandory_field">*</span>
              </h5>
              <span
                className="error-text"
                style={{
                  color: "red",
                  display: errors.oilBottles ? "block" : "none",
                }}
              >
                {errors.oilBottles}
              </span>
            </div>
            <div className="col-md-9">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn btn-outline-secondary ${
                    oilBottles === "2qt" ? "active" : ""
                  }`}
                  onClick={() => handleOilBottlesChange("2qt")}
                >
                  1 Bottle
                </button>
                <button
                  className={`btn btn-outline-secondary ${
                    oilBottles === "3qt" ? "active" : ""
                  }`}
                  onClick={() => handleOilBottlesChange("3qt")}
                >
                  2 Bottles
                </button>
                <button
                  className={`btn btn-outline-secondary ${
                    oilBottles === "noOil" ? "active" : ""
                  }`}
                  onClick={() => handleOilBottlesChange("noOil")}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="section">
          <div className="row align-items-center">
            <div className="col-md-3">
              <h5 className="mb-0">
                Snow Brush in Car? <span className="mandory_field">*</span>
              </h5>
              <span
                className="error-text"
                style={{
                  color: "red",
                  display: errors.snowBrush ? "block" : "none",
                }}
              >
                {errors.snowBrush}
              </span>
            </div>
            <div className="col-md-9">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn btn-outline-secondary ${
                    snowBrush === "yes" ? "active goodActive" : ""
                  }`}
                  onClick={() => handleSnowBrushChange("yes")}
                >
                  Yes
                </button>
                <button
                  className={`btn btn-outline-secondary ${
                    snowBrush === "noAdded" ? "active needRepairActive" : ""
                  }`}
                  onClick={() => handleSnowBrushChange("noAdded")}
                >
                  No, Added Snow Brush
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="section">
          <div className="row align-items-center">
            <div className="col-md-3">
              <h5 className="mb-0">
                Come to Office to Verify 2nd Key?{" "}
                <span className="mandory_field">*</span>
              </h5>
              <span
                className="error-text"
                style={{
                  color: "red",
                  display: errors.verifyKey ? "block" : "none",
                }}
              >
                {errors.verifyKey}
              </span>
            </div>
            <div className="col-md-9">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn btn-outline-secondary ${
                    verifyKey === "yes" ? "active goodActive" : ""
                  }`}
                  onClick={() => handleVerifyKeyChange("yes")}
                >
                  Yes
                </button>
                <button
                  className={`btn btn-outline-secondary ${
                    verifyKey === "no" ? "active needRepairActive" : ""
                  }`}
                  onClick={() => handleVerifyKeyChange("no")}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="section">
          <div className="row">
            <div className="col-md-3">
              <h5>
                Details of Repair Done: <span className="mandory_field">*</span>
              </h5>
              <span
                className="error-text"
                style={{
                  color: "red",
                  display: errors.repairDetails ? "block" : "none",
                }}
              >
                {errors.repairDetails}
              </span>
            </div>
            <div className="col-md-9">
              <textarea
                className="form-control"
                rows="2"
                value={repairDetails}
                onChange={handleRepairDetailsChange}
              ></textarea>
            </div>
          </div>
        </div>
        <div className="section">
          <div className="row">
            <div className="col-md-3">
              <h5>Pictures of repairs: </h5>
            </div>
            <div className="section">
              <div className="media-upload-section">
                <div className="row">
                  <div className="col-sm">
                    <div className="img_upd_contr">
                      {" "}
                      <div
                        className="media-placeholder upload_img_contr"
                        onClick={() => {
                          if (uploadedImages3.length < 4) {
                            document.getElementById("fileInput2").click();
                          }
                        }}
                        style={{
                          opacity: uploadedImages3.length >= 4 ? 0.5 : 1,
                          pointerEvents:
                            uploadedImages3.length >= 4 ? "none" : "auto",
                        }}
                      >
                        <div className="empty-upload-text">
                          <i className="bi bi-cloud-upload"></i>
                          <span>Browse</span>
                        </div>

                        <input
                          type="file"
                          id="fileInput2"
                          accept="image/*"
                          multiple
                          style={{ display: "none" }}
                          onChange={handleFileChange3}
                        />
                      </div>
                      <div
                        className="media-placeholder capcureImg"
                        onClick={openCamera3}
                        style={{
                          opacity: uploadedImages3.length >= 4 ? 0.5 : 1,
                          pointerEvents:
                            uploadedImages3.length >= 4 ? "none" : "auto",
                        }}
                      >
                        <div className="empty-upload-text">
                          <i className="bi bi-cloud-upload"></i>
                          <span>Capture</span>
                        </div>

                        <input
                          type="file"
                          id="fileInput"
                          accept="image/*"
                          multiple
                          style={{ display: "none" }}
                          onChange={handleFileChange3}
                        />
                      </div>
                    </div>
                  </div>
                  {[...Array(4)].map((_, index) => (
                    <div
                      key={index}
                      className="col-sm"
                      style={{ position: "relative" }}
                    >
                      {uploadedImages3[index] && (
                        <div
                          className="hoverRemoveImg"
                          onClick={() => handleRemoveImage3(index)}
                        >
                          <XIcon className="rmv_icn" />
                        </div>
                      )}
                      <div className="media-placeholder car-image">
                        {uploadedImages3[index] ? (
                          <img
                            src={
                              ImageLink + uploadedImages3[index] ||
                              "/placeholder.svg"
                            }
                            alt={`Uploaded ${index + 1}`}
                            style={{ maxWidth: "100%", maxHeight: "100%" }}
                          />
                        ) : (
                          <div
                            className="empty-upload-text"
                            style={{ opacity: "0.5" }}
                          >
                            <UploadIcon size={20} color="#aaa" />
                            <span style={{ marginLeft: "10px" }}>Empty</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {isCameraOpen3 && (
                <div
                  className="camera-modal"
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.9)",
                    zIndex: 1000,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                  }}
                >
                  <div className="container" style={{ maxWidth: "1200px" }}>
                    <div
                      className="row"
                      style={{
                        backgroundColor: "#222",
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div className="col-8" style={{ padding: "0" }}>
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#000",
                            minHeight: "400px",
                          }}
                        >
                          <Webcam
                            ref={webcamRef}
                            audio={false}
                            screenshotFormat="image/jpeg"
                            videoConstraints={{
                              width: 1280,
                              height: 720,
                              facingMode: "user",
                            }}
                            onUserMediaError={handleWebcamError}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </div>
                      <div
                        className="col-4"
                        style={{
                          padding: "20px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          backgroundColor: "#333",
                        }}
                      >
                        <h4
                          style={{
                            color: "white",
                            marginBottom: "20px",
                            textAlign: "center",
                          }}
                        >
                          Camera Capture
                        </h4>
                        <p
                          style={{
                            color: "#ccc",
                            marginBottom: "30px",
                            textAlign: "center",
                          }}
                        >
                          Position yourself in the frame and click "Take Photo"
                          when ready.
                        </p>
                        <button
                          onClick={captureImage3}
                          style={{
                            padding: "12px 0",
                            margin: "10px 0",
                            backgroundColor: "var(--primary-color)",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                        >
                          Take Photo
                        </button>
                        <button
                          onClick={() => {
                            closeCamera();
                          }}
                          style={{
                            padding: "12px 0",
                            margin: "10px 0",
                            backgroundColor: "#f44336",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="section">
          <div className="row">
            <div className="col-md-3">
              <h5>Notes for Future:</h5>
              <span
                className="error-text"
                style={{
                  color: "red",
                  display: errors.futureNotes ? "block" : "none",
                }}
              >
                {errors.futureNotes}
              </span>
            </div>
            <div className="col-md-9">
              <textarea
                className="form-control"
                rows="2"
                value={futureNotes}
                onChange={handleFutureNotesChange}
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>

        <button className="btn next__button" onClick={handleNext}>
          Next
        </button>
      </div>
    </>
  );
};

export default FinalChecks;
